export const caseStoreConst = {
  id: 'id',
  tblTrans: 'tblTrans',
  primaryKey: 'primaryKey',
  caseType: 'caseType',
  caseContext: 'caseContext',
  operation: 'operation'
};
